/**
 * The fields a programme change needs before its workspace is created.
 *
 * @module components/portfolio/change-draft
 */

import type { FieldProblem } from "@/utils/field-problems";

export type ChangeDraftField = "label" | "rationale";

export interface ChangeDraft {
  label: string;
  rationale: string;
}

/** The control id each field renders with, so a problem can be focused. */
export const CHANGE_DRAFT_IDS: Record<ChangeDraftField, string> = {
  label: "portfolio-change-label",
  rationale: "portfolio-change-rationale",
};

/**
 * @returns Every problem, in the order the fields appear on screen.
 */
export function validateChangeDraft(draft: ChangeDraft): FieldProblem<ChangeDraftField>[] {
  const problems: FieldProblem<ChangeDraftField>[] = [];
  if (!draft.label.trim()) {
    problems.push({ field: "label", message: "Add an institutional revision label." });
  }
  if (!draft.rationale.trim()) {
    problems.push({ field: "rationale", message: "Explain why this change is being opened." });
  }
  return problems;
}
